import { produce } from "immer";
import { Dimensions } from "react-native";
import { kWindowBreakpoints } from "./thunkActions";
import {
  tNavigationAction,
  tNavigationState,
  tScreenDimension,
  tSetBackButtonRoute,
  tUpdateDeviceSize,
  tUpdateDrawerType,
  tUpdateFooterType,
} from "./types";

const _getInitialDeviceSize = (): tScreenDimension => {
  const { width } = Dimensions.get("window");
  if (width >= kWindowBreakpoints.lg) return "lg";
  else if (width < kWindowBreakpoints.lg && width >= kWindowBreakpoints.md) return "md";
  else if (width < kWindowBreakpoints.md && width >= kWindowBreakpoints.sm) return "sm";
  return "xs";
};

const kDefaultNavigationState: tNavigationState = {
  drawerType: Dimensions.get("window").width > 1000 ? "permanent" : "slide",
  footerType: Dimensions.get("window").height <= 1000 ? "small" : "big",
  productMode: "CREATE",
  deviceSize: _getInitialDeviceSize(),
  backButtonRoute: undefined,
  currentRouteName: undefined,
};

const handleUpdateDrawerType = (state: tNavigationState, action: tUpdateDrawerType): tNavigationState => {
  return { ...state, drawerType: action.drawerType };
};

const handleUpdateFooterType = (state: tNavigationState, action: tUpdateFooterType): tNavigationState => {
  return { ...state, footerType: action.footerType };
};

const handleUpdateDeviceSize = (state: tNavigationState, action: tUpdateDeviceSize): tNavigationState => {
  return { ...state, deviceSize: action.deviceSize };
};

const handleSetBackButtonRoute = (state: tNavigationState, action: tSetBackButtonRoute) => {
  return { ...state, backButtonRoute: action.backButtonRoute };
};

export const NavigationReducer = produce(
  (state: tNavigationState = kDefaultNavigationState, action: tNavigationAction): tNavigationState => {
    switch (action.type) {
      case "UPDATE_DRAWER_TYPE":
        return handleUpdateDrawerType(state, action);
      case "UPDATE_FOOTER_TYPE":
        return handleUpdateFooterType(state, action);
      case "UPDATE_DEVICE_SIZE":
        return handleUpdateDeviceSize(state, action);
      case "SET_BACK_BUTTON_ROUTE":
        return handleSetBackButtonRoute(state, action);
      case "SET_CURRENT_ROUTE_NAME":
        return { ...state, currentRouteName: action.payload };
      default:
        return state;
    }
  },
);
